import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { _className } from '@nu-art/thunderstorm-frontend/index';
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import './AdvisorPanel_AddProtocolData.scss';
import { Renderer_AddProtocol } from './renderers/Renderer_AddProtocol/Renderer_AddProtocol.js';
import { ICONS } from '@app/styles';
import { ConsiderationGroupEnum } from '@app/advisor-shared';
import { Renderer_ProtocolTitle } from '../../components/Renderer_ProtocolTitle/Renderer_ProtocolTitle.js';
import { Renderer_AddOrder } from './renderers/Renderer_AddOrder/Renderer_AddOrder.js';
import { dispatch_OnAddProtocol } from './renderers/Renderer_AddProtocol/dispatchers.js';
import { ModuleFE_AdvisorAnalytics } from '../../../_analytics/consts.js';
import { ColumnKey_RightColumn, PanelKey_AddProtocolData, ProtocolInteractionType_AddOrder, ProtocolInteractionType_AddProtocol, RightColumnNew_AddData, RightColumnNew_Base } from '@app/advisor-v5-shared';
import { ModuleFE_ProtocolInteraction } from '../../../_enum/protocol-interaction/index.js';
import { ModuleFE_AdvisorBoard } from '../../../_enum/advisor-board/index.js';
const relevantInteractionTypes = [ProtocolInteractionType_AddProtocol, ProtocolInteractionType_AddOrder];
export class AdvisorPanel_AddProtocolData extends AdvisorPanel {
    static defaultProps = {
        panelKey: PanelKey_AddProtocolData,
    };
    //######################### Life Cycle #########################
    __onAddProtocol(consideration) {
        this.setState({ interaction: consideration ? { consideration } : undefined });
        //Report analytics data
        if (consideration)
            ModuleFE_AdvisorAnalytics.trigger.addData.addData_ddx_open({ considerationLevel: consideration });
    }
    __onProtocolInteraction = () => {
        const interaction = ModuleFE_ProtocolInteraction.getInteraction();
        if (!interaction || !relevantInteractionTypes.includes(interaction.type))
            return this.setState({ interaction: undefined });
        this.setState({ interaction: interaction });
        //Report analytics data
        if (interaction.type === ProtocolInteractionType_AddOrder)
            ModuleFE_AdvisorAnalytics.trigger.addData.addData_order_open();
    };
    componentDidUpdate(prevProps, prevState) {
        //Opening the panel
        if (this.state.interaction && !prevState.interaction)
            return ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_RightColumn, RightColumnNew_AddData);
        //Closing the panel
        if (!this.state.interaction && prevState.interaction)
            ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_RightColumn, RightColumnNew_Base);
    }
    //######################### Logic #########################
    getPanelClass() {
        const isFloating = this.props.context === 'floating';
        return _className(super.getPanelClass(), 'panel__add-protocol-data', isFloating && 'special-panel', isFloating && 'interactive');
    }
    //######################### Render - Header #########################
    renderHeader_Title = () => {
        if (!this.state.interaction)
            return 'Add Protocol Data';
        if ('consideration' in this.state.interaction)
            return 'Add Protocol';
        else
            return 'Add Order';
    };
    renderHeader_Tail = () => {
        return _jsx(ICONS.advisor_avn_close.component, { onClick: () => {
                // close the add protocol interaction
                if ('consideration' in (this.state.interaction ?? {})) {
                    //Report analytics event
                    ModuleFE_AdvisorAnalytics.trigger.addData.addData_ddx_abandon();
                    return dispatch_OnAddProtocol.dispatchUI();
                }
                //Report analytics event
                ModuleFE_AdvisorAnalytics.trigger.addData.addData_order_abandon();
                ModuleFE_ProtocolInteraction.closeInteraction();
            } });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = () => {
        if (!this.state.interaction)
            return _jsx(_Fragment, {});
        if ('consideration' in this.state.interaction) {
            const interaction = this.state.interaction;
            return `Add protocol to ${interaction.consideration === ConsiderationGroupEnum.HIGH_CONSIDERATION ? 'high' : 'low'} consideration`;
        }
        else {
            const interaction = this.state.interaction;
            return _jsx(Renderer_ProtocolTitle, { protocolId: interaction.protocolId });
        }
    };
    //######################### Render - Content #########################
    _renderContent = (scrollRef) => {
        if (!this.state.interaction)
            return _jsx(_Fragment, {});
        if ('consideration' in this.state.interaction) {
            const interaction = this.state.interaction;
            return _jsx(Renderer_AddProtocol, { consideration: interaction.consideration, scrollRef: scrollRef });
        }
        else {
            const interaction = this.state.interaction;
            return _jsx(Renderer_AddOrder, { protocolId: interaction.protocolId, scrollRef: scrollRef });
        }
    };
    renderContent = () => _jsx(_Fragment, {});
    //######################### Render - Footer #########################
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorPanel_AddProtocolData.js.map